<template>
  <div id="calendar">
    <FullCalendar
      class="mt-3"
      defaultView="resourceTimeline"
      :plugins="calendarPlugins"
      :events="events"
      :resources="resources"
      :height="height"
    />
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import timeline from "@fullcalendar/resource-timeline";

export default {
  components: {
    FullCalendar
  },
  data() {
    return {
      calendarPlugins: [timeline],
      height: "parent",
      events: [
        {
          title: "Event Now",
          start: new Date(),
          end: new Date() + 60000 * 60,
          resourceId: 1
        }
      ],
      resources: [
        {
          id: "1",
          title: "IR # 1289"
        }
      ]
    };
  }
};
</script>

<style lag="scss" scoped>
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/timeline/main.css";
@import "~@fullcalendar/resource-timeline/main.css";

#calendar {
  height: calc(100vh - 150px);
  width: calc(100vw - 20px);
  margin-left: auto;
  margin-right: auto;
}
</style>